import Division from '../../../components/Division'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import Fragment from '../../../components/Fragment'
import useStyles from './styles'
import ImageNavigation from '../../../components/ImageNavigation'
import placeholder from '../../../../../../assets/images/neu-placeholder.png'

const BANNER_SLUG = 'results_section_story_image'

const SectionTellStory = (props) => {
  const desktop = isWidthUp('md', props.width)
  const classes = useStyles({ desktop })
  const fragments = useSelector((state) => state.local.fragments)
  const [cookies] = useCookies(['neu_nclb_admin'])
  const [index, setIndex] = useState(null)
  const [valid, setValid] = useState(false)

  useEffect(() => {
    const bannerIndex = fragments[BANNER_SLUG]?.content
    if (!isNaN(bannerIndex)) setIndex(Number(bannerIndex))
  }, [fragments])

  useEffect(() => {
    setValid(index && !isNaN(index))
  }, [index])

  const chunks = (chunk) => {
    switch (chunk) {
      case 'title':
        return (
          <Typography
            variant="h4"
            align={desktop ? 'left' : 'center'}
            style={{ margin: 0 }}
            component="div"
          >
            <Fragment title="results_section_5_title" fragments={props.fragments} />
          </Typography>
        )
      case 'image':
        return (
          <img
            src={
              valid
                ? `img/banner-${index}-${desktop ? 'desktop' : 'mobile'}.jpg`
                : placeholder
            }
            alt="Children"
            className={classes.image}
          />
        )

      case 'action':
        return (
          <div>
            <Typography
              variant="h5"
              className={classes.fragment}
              align={desktop ? 'left' : 'center'}
              component="div"
            >
              <Fragment
                title="results_section_5_action_title"
                fragments={props.fragments}
              />
            </Typography>
            <Typography
              variant="body1"
              className={classes.fragment}
              align="left"
              component="div"
            >
              <Fragment
                title="results_section_5_action_paragraph"
                fragments={props.fragments}
              />
            </Typography>
            <Button
              color="secondary"
              variant="contained"
              size="large"
              fullWidth={!desktop}
              onClick={() => (window.location.href = '/story')}
              className={classes.button}
            >
              <Fragment
                title="results_section_5_action_button"
                fragments={props.fragments}
              />
            </Button>
          </div>
        )
    }
  }

  return desktop ? (
    <Grid
      item
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={5}
      className={classes.storyContainer}
    >
      <Grid item md={5} lg={4}>
        {chunks('title')}
        <Division padding={20} left={desktop} />
        {chunks('action')}
      </Grid>
      <Grid item md={5} lg={4} style={{ position: 'relative' }}>
        {cookies['neu_nclb_admin'] && (
          <ImageNavigation
            index={index}
            updateIndex={setIndex}
            slug={BANNER_SLUG}
            style={{
              left: 25,
              top: 25,
              width: 'auto',
              bottom: 'inherit',
              background: 'rgba(0,0,0,0.3)',
            }}
          />
        )}
        {chunks('image')}
      </Grid>
    </Grid>
  ) : (
    <Grid item container justify="center">
      {chunks('title')}
      <Division padding={20} />
      {chunks('image')}
      {chunks('action')}
    </Grid>
  )
}

export default withWidth()(SectionTellStory)
